import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon, Modal, Popover } from 'antd'


class ItemImage extends Component {
    state = {
        visible: false,
    }

    componentDidCatch(error, errorInfo) {
        console.log("ERROR__", error)
        console.log("ERROR__errorInfo", errorInfo)
    }

    _showModal = () => {
        this.setState({
            visible: true,
        })
    }

    _hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    _afterDoAction = (status) => {
        this.props.onChangeStatus(status)

        this._hideModal()
    }

    render() {
        const { visible } = this.state
        const { image, previewImage, type, size, safezoneImage, piece_errors, piece_hovers } = this.props

        const showSafeZone = (category, dimension) => {
            if (!!safezoneImage) {
                return <img src={safezoneImage} alt="SafeZone" className="Safezone" />
            }
        }

        return (

            <div className='ItemImage'>
                {
                    previewImage ?
                        <div className='Preview position-relative'>
                            <img src={previewImage} alt='preview' />
                            {
                                piece_errors.length > 0 && piece_errors.map((item, index) => (
                                    item.mark_error && <img key={index} src={item.url || ''} alt='preview' className='Safezone' />
                                ))
                            }
                            {
                                piece_hovers.length > 0 && piece_hovers.map((item, index) => (
                                    item.isHover && <img key={index} src={item.zone || ''} alt='preview' className='Safezone' />
                                ))
                            }
                            {
                                showSafeZone(type, size)
                            }

                            <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                <span className='Icon cursor-pointer mr-2' onClick={this._showModal}><Icon
                                    type='eye' /></span>

                                <a href={image} download className='Icon Download'><Icon type="download" /></a>
                            </div>

                            <Modal visible={visible} closable={false} centered={true} footer={null} width={1200}
                                onCancel={this._hideModal} className='PrintedFileModal'>
                                <div className="Previewer">
                                    <img src={previewImage} alt='preview' className='d-block m-auto' />
                                    {
                                        showSafeZone(type, size)
                                    }
                                </div>
                            </Modal>
                        </div>
                        : image &&
                        <a href={image} target='_blank' rel='noreferrer noopener'
                            className='btn btn-sm text-primary'><u>Download</u></a>
                }
            </div>
        )
    }
}

ItemImage.propTypes = {
    image: PropTypes.string,
    previewImage: PropTypes.string,
    type: PropTypes.string.isRequired,
    batchItem: PropTypes.object.isRequired,
    size: PropTypes.string,
    item_number: PropTypes.number.isRequired,
    safezoneImage: PropTypes.string
}

export default ItemImage
